import styled from '@emotion/styled';
import { Button as _Button, IconButton, List, ListItem, Modal, Paper, Typography, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { createElement, FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import Organization from '../../../../entity/Organization';
import theme from '../../../../theme';
import {
  COLOR_MENU_BACKGROUND,
  COLOR_MENU_HEADER,
  COLOR_SECONDARY_BUTTON_BACKGROUND_MAIN,
  COLOR_TEXT_MAIN,
} from '../../../constant/color';
import OrganizationsSelect from '../OrganizationsSelect';

interface Props {
  organizations: Organization[] | null;
  currentOrgOrAccount: Organization | null;
  className?: string;
  setCurrentOrgOrAccount: (organization: Organization) => void;
}

const CommonMenu: FC<Props> = ({ organizations, currentOrgOrAccount, className, setCurrentOrgOrAccount }) => {
  const [open, setOpen] = useState(false);

  const onClickMenu = () => {
    setOpen(true);
  };

  const onRequestClose = () => {
    setOpen(false);
  };

  return (
    <Root className={className}>
      <IconButton onClick={onClickMenu}>
        <MoreHorizIcon style={{ color: COLOR_SECONDARY_BUTTON_BACKGROUND_MAIN }} />
      </IconButton>
      <Modal
        open={open}
        onClose={onRequestClose}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <StyledPaper style={{ width: '80%', backgroundColor: COLOR_MENU_BACKGROUND, borderRadius: 8 }}>
          <List
            style={{
              padding: 0,
            }}
          >
            <ListItem
              style={{
                height: 48,
                display: 'flex',
                justifyContent: 'space-between',
                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.16)',
                backgroundColor: COLOR_MENU_HEADER,
                borderRadius: '8px 8px 0px 0px',
              }}
            >
              <Typography
                variant="body1"
                style={{
                  position: 'static',
                  fontSize: 16,
                  fontWeight: 700,
                  color: COLOR_TEXT_MAIN,
                }}
              >
                <FormattedMessage id="menu.common_menu" />
              </Typography>
              <IconButton onClick={onRequestClose} style={{ width: 28, height: 28 }}>
                <CloseIcon style={{ color: COLOR_TEXT_MAIN, width: 24, height: 24 }} />
              </IconButton>
            </ListItem>
            <List
              style={{
                padding: '24px',
              }}
            >
              <Typography
                style={{
                  position: 'static',
                  fontSize: 12,
                  fontWeight: 700,
                  color: '#CACACA',
                  marginBottom: 12,
                }}
              >
                <FormattedMessage id="headbar.organization_select.title" />
              </Typography>
              {organizations && organizations.length > 0 ? (
                <OrganizationsSelect
                  currentOrganizationId={currentOrgOrAccount ? currentOrgOrAccount.id : null}
                  organizations={organizations}
                  onChangeCurrentOrganization={(organization: Organization) => {
                    setCurrentOrgOrAccount(organization);
                  }}
                  isSmartPhone={false}
                />
              ) : null}
            </List>
          </List>
        </StyledPaper>
      </Modal>
    </Root>
  );
};

export const MENU_ITEM_HEIGHT = 48;

const Root = styled('div')({
  display: 'flex',
});

const StyledPaper = withStyles({
  rounded: {
    borderRadius: 0,
  },
  elevation1: {
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.16)',
  },
  [theme.breakpoints.up('sm')]: {
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50% -50%)',
  },
})(Paper);

export default CommonMenu;
